import axios from "axios";

const FacematchAxiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_FACE_MATCH_URL}v1`,
});

const onRequest = async (request) => {
  const accessToken = JSON.parse(localStorage.getItem("currUserToken"));
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`;
  } else {
    // console.log('axios auth token not found', request.)
  }
  return request;
};

const onRequestError = (error) => {
  // console.log(`Axios request interceptor error`, error)
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = async (error) => {
  // console.log(`API response error`, error)
  if (error.response.status === 401) {
    window.location.pathname = "/signin";
  }
  return Promise.reject(error);
};

FacematchAxiosClient.interceptors.request.use(onRequest, onRequestError);
FacematchAxiosClient.interceptors.response.use(onResponse, onResponseError);

export { FacematchAxiosClient };
